import React, {Component} from "react"
import PropTypes from "prop-types"
import {Button, ButtonGroup, Glyphicon, Panel} from 'react-bootstrap'
import ExitForm, {createExitInitialValues} from './ExitForm'
import * as Date from "../../utils/date"
import {ExitTypeLabel} from "../../utils/enums";
import {Enums} from "../../utils";
import type {ItemTableContext} from "./helpers";
import {formatItemActions, renderItemTable} from "./helpers";
import {formatExitDescription} from "../../utils/format";

class DogExits extends Component {

	tableCtx: ItemTableContext;

	constructor(props) {
		super(props)

		this.state = {
			itemModalOpen: false,
			exitId: null
		}

		this.handleItemModalClick = this.handleItemModalClick.bind(this);
		this.handleItemModalDismiss = this.handleItemModalDismiss.bind(this);

		this.tableCtx = {
			itemKeyName: 'exitId',
			cols: [
				{title: 'Datum', width: 17},
				{title: 'Typ', width: 19},
				{title: 'Popis', width: 37},
				{title: 'Provedl', width: 17},
			],
			renderRow: (item, files, props) => {
				const {enums} = props;
				return <tr key={item.exitId} title={item.createdBy && Enums.getEnumTitle(enums, 'user', item.createdBy) + ' ' + Date.formatDateTime(item.createdAt)}>
					<td title={item.exitId}>
						{Date.formatDate(item.exitAt)}
					</td>
					<td>{ExitTypeLabel[item.exitType]}</td>
					<td>{formatExitDescription(item)}</td>
					<td>{item.exitBy && Enums.getEnumTitle(enums, 'user', item.exitBy)}</td>
					<td>{formatItemActions(item, 'exitId', files, this.handleItemModalClick)}</td>
				</tr>
			}
		}
	}

	componentWillMount() {
		this.props.onFetchData(this.props.dogId)
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.dogId !== this.props.dogId) {
			this.props.onFetchData(nextProps.dogId)
		}
	}

	handleItemModalClick(exitId) {
		this.setState({itemModalOpen: true, exitId})
	}

	handleItemModalDismiss() {
		this.setState({itemModalOpen: false, exitId: null})
	}

	renderItemModal() {
		const {dogId, session} = this.props;
		const {itemModalOpen, exitId} = this.state;
		if (!itemModalOpen) {
			return null
		}
		return <ExitForm exit={createExitInitialValues(exitId, dogId, session)} modal={{
			onHide: this.handleItemModalDismiss,
			onSuccess: (item) => this.props.onFetchData(item.dogId, true)
		}}/>
	}

	render() {
		return <Panel>
			<Panel.Heading>
				<div className={'panel-title'}>
					Výdej
					<ButtonGroup className="pull-right">
						<Button type="button" className="btn btn-default btn-xs" onClick={() => this.handleItemModalClick(null)}><Glyphicon glyph="plus"/> Přidat</Button>
					</ButtonGroup>
				</div>
			</Panel.Heading>
			<Panel.Body>
				{renderItemTable(this.tableCtx, this.props)}
				{this.renderItemModal()}
			</Panel.Body>
		</Panel>
	}
}

DogExits.propTypes = {
	dogId: PropTypes.number.isRequired,
	files: PropTypes.array,
	onFetchData: PropTypes.func.isRequired,
	onShowModal: PropTypes.func.isRequired,
	session: PropTypes.object.isRequired
}

export default DogExits



// WEBPACK FOOTER //
// ./src/components/dog/DogExits.js